import React from 'react'
import { ProductGalleryView } from '../../product/views'
import { ProductDescriptionView } from '../../product/views'
import { ProductBuilderNextView } from './next'
import Grid from '@material-ui/core/Grid'
import makeStyles from '@material-ui/styles/makeStyles'
import { connect } from 'react-redux'
import { ProductBuilderState } from '../state'

const useStyles = makeStyles((theme: any) => ({
    root: {
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row',
            '& .description-item': {
                padding: theme.spacing(0, 2)
            }
        }
    }
}), { name: 'ProductBuilderStepStart' })

export const productBuilderStepStartView = (props: ProductBuilderState) => {
    const classes = useStyles(props)
    return <Grid container className={classes.root} direction='column'>
        <Grid item xs={12} md={4} container alignItems='flex-start'>
            <ProductGalleryView product={props.product} />
        </Grid>
        <Grid item xs={12} md={5} className='description-item'>
            <ProductDescriptionView product={props.product} />
        </Grid>
        <Grid item xs={12} md={3} container alignItems='stretch'>
            <ProductBuilderNextView />
        </Grid>
    </Grid>
}

export const ProductBuilderStepStartView =
    connect((state: any) => state.productBuilderState)(productBuilderStepStartView)
